import { Component, OnInit, OnDestroy } from '@angular/core';
import { CollectorSupportService } from './services/collector-support.service';
import { OrderService } from '../orders/services/order.service';
import { CheckoutService } from '../checkout/services/checkout.service';

@Component({
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class CollectorSupportComponent implements OnInit, OnDestroy {
  constructor(
    private collectorSupportService: CollectorSupportService,
    private orderService: OrderService,
    private checkoutService: CheckoutService
  ) {}

  ngOnInit() {
    this.collectorSupportService.activateSubMenu();
    //this.orderService.checkBusinessDayGur().subscribe(adminKPIExecutive => {
    //    this.checkoutService.newGuranteeDaysMsg(adminKPIExecutive);
    //});
  }

  ngOnDestroy() {
    this.collectorSupportService.deactivateSubMenu();
  }
}
